var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "envelope") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-empty",
    transform: "translate(-37.000000, -299.000000)",
    fill: "#758696",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(21.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8263181,0 L2.48299646,0 C1.11335713,0 0,1.04348315 0,2.32716431 L0,12.1555943 C0,13.4392755 1.11335713,14.4827586 2.48299646,14.4827586 L17.8221168,14.4827586 C19.1917561,14.4827586 20.3051251,13.4392755 20.3051251,12.1555943 L20.3051251,2.33110199 C20.3093146,1.04742082 19.1959574,0 17.8263181,0 Z M19.1749507,12.1555943 C19.1749507,12.8525623 18.5699566,13.4195871 17.8263181,13.4195871 L2.48299646,13.4195871 C1.73935793,13.4195871 1.13436387,12.8525623 1.13436387,12.1555943 L1.13436387,2.33110199 C1.13436387,1.63413399 1.73935793,1.06710919 2.48299646,1.06710919 L17.8221168,1.06710919 C18.5657553,1.06710919 19.1707493,1.63413399 19.1707493,2.33110199 L19.1707493,12.1555943 L19.1749507,12.1555943 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8014791,7.12016612 L17.7652045,3.07487978 C17.9961731,2.88406439 18.0171703,2.55967822 17.8071988,2.34596498 C17.5972273,2.13606804 17.2402758,2.1169865 17.0051078,2.3078019 L10.1600381,7.89106031 L8.82461956,6.80722888 C8.82042013,6.80341257 8.8162207,6.79959626 8.8162207,6.79577995 C8.78682469,6.7690658 8.75742869,6.74616795 8.72383325,6.7232701 L3.28977176,2.30398559 C3.05460373,2.1131702 2.69765224,2.13225173 2.48768077,2.34596498 C2.27770931,2.55967822 2.29870645,2.88406439 2.53387449,3.07487978 L7.55639191,7.15451289 L2.55487164,11.4096962 C2.32810246,11.6043279 2.31550417,11.928714 2.52967507,12.138611 C2.64305966,12.2454676 2.79423911,12.3027122 2.94541856,12.3027122 C3.08399973,12.3027122 3.2225809,12.2569165 3.33176606,12.1653251 L8.40887606,7.84908093 L9.78628886,8.96725913 C9.89547402,9.05503421 10.0298558,9.0970136 10.1642375,9.0970136 C10.2986192,9.0970136 10.4372004,9.05121791 10.5421861,8.96344282 L11.9573938,7.81091785 L17.0051078,12.1691414 C17.114293,12.2645491 17.2570736,12.3103448 17.3956547,12.3103448 C17.5468342,12.3103448 17.6938142,12.2569165 17.8071988,12.1500599 C18.0213697,11.9439793 18.0129708,11.6157768 17.7862016,11.4211451 L12.8014791,7.12016612 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.74c05ad4.svg";
export { ForwardRef as ReactComponent };